import { INewCaptureInfo } from '../../types'
import CaptureInfoManager from './manager'
import SectionButtons from './section-buttons'
import Sections from './sections'
import CreationToolSuperCutSection from '../../../../../types/super-cut-section'

type Props = {
    className?: string
    captureInfo?: INewCaptureInfo
    uploadProgress?: number
    isUploading?: boolean
    saveLabel: string
    onSave: (info: INewCaptureInfo) => void
    onUpdate?: (hasChanges: boolean, info: INewCaptureInfo) => void
    onCancel: () => void
    isEditMode?: boolean
    onSectionChange: (section: CreationToolSuperCutSection) => void
}

const CreationCaptureInfo = ({
    className,
    captureInfo,
    uploadProgress,
    isUploading = false,
    saveLabel,
    onSave,
    onUpdate,
    onCancel,
    isEditMode,
    onSectionChange,
}: Props) => {
    return (
        <CaptureInfoManager
            {...{
                defaultTitle: captureInfo?.title,
                defaultTags: captureInfo?.tags,
                defaultUsername: captureInfo?.username,
                defaultWatermark: captureInfo?.watermark,
                defaultWatermarkPosition: captureInfo?.watermarkPosition,
                defaultFont: captureInfo?.font,
                defaultPreviousFonts: captureInfo?.font ? [captureInfo?.font] : undefined,
                defaultSourceUrl: captureInfo?.sourceUrl,
                defaultRating: captureInfo?.rating,
                defaultIsPublic: captureInfo?.isPublic,
                defaultHasAutoCaption: captureInfo?.hasCaptions,
                defaultSegmentationType: captureInfo?.segmentationType,
                defaultLanguages: captureInfo?.languages,
                defaultDescription: captureInfo?.description,
                defaultCaptionStyle: captureInfo?.captionStyle,
                defaultIsEditPanel: isEditMode,
                onUpdate,
            }}
        >
            <Sections className={className} isEditMode={isEditMode} onSectionChange={onSectionChange} />
            <SectionButtons
                {...{
                    className: className,
                    defaultLabel: saveLabel,
                    uploadProgress: uploadProgress,
                    isUploading: isUploading,
                    defaultOnSave: onSave,
                    defaultOnCancel: onCancel,
                }}
            />
        </CaptureInfoManager>
    )
}

export default CreationCaptureInfo
